import { makeObservable, observable, action, reaction, computed } from 'mobx';
import { Disposer } from '../../custom_shared/misc';
import { LayoutSettingsFactory } from '../factories';
import { InstanceUtils } from '../misc';
import { LayoutSettingsBaseModel } from '../models';
import SessionStore from './SessionStore';

export default class SettingsStore extends Disposer {
    modalVisible: boolean = false;

    layoutSettings: LayoutSettingsBaseModel | null = null;

    layoutSettingsOptions: LayoutSettingsBaseModel[] = [];

    changedLayoutType: string | null = null;

    constructor(private readonly sessionStore: SessionStore) {
        super();

        this.reactions.push(
            reaction(
                () => this.sessionStore.response,
                response => {
                    if (!response) {
                        return;
                    }

                    this.setLayoutSettings(LayoutSettingsFactory.createSettings(response.layoutSettings));
                    this.setLayoutSettingsOptions(
                        response.layoutSettingsOptions.map(LayoutSettingsFactory.createSettings)
                    );
                }
            )
        );

        makeObservable(this, {
            modalVisible: observable,
            layoutSettings: observable,
            layoutSettingsOptions: observable,
            changedLayoutType: observable,
            setModalVisible: action,
            setLayoutSettings: action,
            setLayoutSettingsOptions: action,
            setChangedLayoutType: action,
            selectedLayoutSettings: computed,
            isBasicLayoutSettings: computed,
            isLayersLayoutSettings: computed,
            settingsHasLayers: computed
        });
    }

    setModalVisible(modalVisible: boolean) {
        this.modalVisible = modalVisible;
    }

    setLayoutSettings(layoutSettings: LayoutSettingsBaseModel) {
        this.layoutSettings = layoutSettings;
    }

    setLayoutSettingsOptions(layoutSettingsOptions: LayoutSettingsBaseModel[]) {
        this.layoutSettingsOptions = layoutSettingsOptions;
    }

    setChangedLayoutType(changedLayoutType: string | null) {
        this.changedLayoutType = changedLayoutType;
    }

    get selectedLayoutSettings() {
        if (this.changedLayoutType) {
            return this.layoutSettingsOptions.find(settings => settings.type === this.changedLayoutType) ?? null;
        }

        return this.layoutSettings;
    }

    get isBasicLayoutSettings() {
        return InstanceUtils.isBasicLayoutSettings(this.layoutSettings);
    }

    get isLayersLayoutSettings() {
        return InstanceUtils.isLayersLayoutSettings(this.layoutSettings);
    }

    get settingsHasLayers() {
        return InstanceUtils.hasLayers(this.layoutSettings);
    }

    dispose() {
        this.disposeReactions();
    }
}
